import React, { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';

export default (): ReactElement<any, any> | null => {
  return <Redirect to={`/seminars/seminars`} />;
};
